enum CalendarPickerScenarioId {
    SurfaceLeftPane = 1, // Calendar picker in the calendar surface left pane,
    AddCalendarModal = 2, // Calendar picker in the add calendars modal popout,
}

export default CalendarPickerScenarioId;
